import { render, staticRenderFns } from "./TechElement.vue?vue&type=template&id=1740b078&scoped=true&"
import script from "./TechElement.vue?vue&type=script&lang=js&"
export * from "./TechElement.vue?vue&type=script&lang=js&"
import style0 from "./TechElement.vue?vue&type=style&index=0&id=1740b078&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1740b078",
  null
  
)

export default component.exports